import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import "./styles.css";
import Container from "../../../components/Container";
import {
  Input,
  Spin,
  notification,
  Button,
  Form,
  Row,
  Col,
  Table,
} from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { doc, getDoc, updateDoc, deleteDoc } from "firebase/firestore";
import { db } from "../../../services/firebase";

const { Password } = Input;
const { Item, useForm } = Form; // 👈 usamos useForm aqui

function UserDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = useForm(); // 👈 criamos a instância do formulário
  const [client, setClient] = useState(null);
  const [unidades, setUnidades] = useState([]);
  const [isEditing, setIsEditing] = useState(false);

  const columns = [
    {
      title: "Ver",
      dataIndex: "id",
      key: "id",
      render: (value) => (
        <Link to={`/admin/cadastro-cliente/${value}`}>
          <EyeTwoTone />
        </Link>
      ),
    },
    {
      title: "Nome",
      dataIndex: "nomeEmpresa",
      key: "nomeEmpresa",
    },
    {
      title: "Unidade",
      dataIndex: "unidade",
      key: "unidade",
    },
  ];

  const fetchUserDetails = useCallback(async () => {
    try {
      const ref = doc(db, "usuarios", id);
      const snapshot = await getDoc(ref);
      const data = { id: snapshot.id, ...snapshot.data() };

      const refClient = doc(db, "clientes", data.cliente_id);
      const snapshotClient = await getDoc(refClient);
      const dataClient = { id: snapshotClient.id, ...snapshotClient.data() };

      const unidadesData = dataClient.unidades.map((item) => ({
        nomeEmpresa: dataClient.nomeEmpresa,
        unidade: item.unidade,
        id: dataClient.id,
      }));

      setUnidades(unidadesData);
      const dadosCombinados = { ...dataClient, ...data };
      setClient(dadosCombinados);

      form.setFieldsValue(dadosCombinados); // 👈 aqui o form preenche os campos
    } catch (error) {
      console.error("Erro ao buscar detalhes do usuário:", error);
    }
  }, [id, form]);

  useEffect(() => {
    fetchUserDetails();
  }, [fetchUserDetails]);

  const handleSave = async () => {
    try {
      const values = form.getFieldsValue(); // 👈 pegamos os valores do form
      const ref = doc(db, "usuarios", id);
      await updateDoc(ref, values);
      alert("Usuário atualizado com sucesso!");
      setIsEditing(false);
    } catch (error) {
      console.error("Erro ao atualizar usuário:", error);
    }
  };

  const handleDelete = async () => {
    if (window.confirm("Tem certeza de que deseja excluir este usuário?")) {
      try {
        await deleteDoc(doc(db, "usuarios", id));
        alert("Usuário deletado com sucesso!");
        navigate("/admin/clientes");
      } catch (error) {
        console.error("Erro ao deletar usuário:", error);
        alert("Erro ao deletar usuário. Verifique o console para mais detalhes.");
      }
    }
  };

  if (!client) {
    return <div>Carregando...</div>;
  }

  return (
    <Container>
      <Form layout="vertical" form={form}> {/* 👈 conectamos o form */}
        <div className="client-details-container">
          <h2>Detalhes do Usuário</h2>

          {/* Agora não precisamos usar value={} nem onChange */}
          <Item label="Nome:" name="nomeUsuario">
            <Input disabled={!isEditing} />
          </Item>

          <Item label="Login" name="loginUsuario">
            <Input disabled={!isEditing} />
          </Item>

          <Item label="Senha:" name="senhaUsuario">
            <Password
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
              disabled={!isEditing}
            />
          </Item>
        </div>

        <div className="client-details-container">
          <h2 className="empresaVinculada">EMPRESA</h2>
          <Table dataSource={unidades} columns={columns} bordered />
        </div>

        <div className="button-group">
          {isEditing ? (
            <Button onClick={handleSave}>Salvar Alterações</Button>
          ) : (
            <Button onClick={() => setIsEditing(true)}>Editar Cadastro</Button>
          )}
          <Button onClick={() => navigate(-1)} className="btn-secondary">
            Voltar
          </Button>
          <Button onClick={handleDelete} className="btn-delete">
            Deletar Usuário
          </Button>
        </div>
      </Form>
    </Container>
  );
}

export default UserDetails;
